/** @jsx jsx */
import {
  ArrowBackIcon,
  Box,
  Button,
  Container,
  DottedList,
  DottedListItem,
  Flex,
  Heading,
  Paragraph,
  TypeApplicationIcon,
} from "@eworkit/iris";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { jsx } from "theme-ui";

import { IContract } from "@/data/contracts";
import { usePreviousRoutePath } from "@/infrastructure/Route";
import { router } from "@/views/router";

import { ContractDetailsTabs } from "./ContractDetailsTabs";

interface ContractDetailsHeaderProps {
  contract: IContract;
}

export const ContractDetailsHeader: FC<ContractDetailsHeaderProps> = ({ contract }) => {
  const { t } = useTranslation("session");

  const { previousPath } = usePreviousRoutePath();
  const contractsPath = useMemo(() => previousPath, []);

  return (
    <Box bg="n0" borderColor="n100" borderBottom="primary" pt="sm">
      <Container>
        <Flex px="sm" flexDirection="column" gap="sm">
          <div>
            <Button
              as={Link}
              to={contractsPath ?? router.get("contracts").path}
              variant="ghost"
              size="sm"
              iconLeft={<ArrowBackIcon />}>
              {t("CONTRACTS.BACK_TO_CONTRACTS")}
            </Button>
          </div>
          <Flex flexDirection={["column", null, null, "row"]} justifyContent="space-between" gap="sm">
            <Flex gap="sm">
              <TypeApplicationIcon color="vg500" size="xl" />
              <Flex flexDirection="column" gap="xxs">
                <Flex
                  flexDirection={["column", null, "row"]}
                  gap={["xxs", null, "xs"]}
                  alignItems={[null, null, "center"]}>
                  <Heading size="h-md" sx={{ fontWeight: 500 }}>
                    {contract.projectName}
                  </Heading>
                </Flex>
                <DottedList>
                  <DottedListItem>
                    <Paragraph color="n700">SC-{contract.supplierContractId}</Paragraph>
                  </DottedListItem>
                </DottedList>
              </Flex>
            </Flex>
          </Flex>
          <ContractDetailsTabs contract={contract} />
        </Flex>
      </Container>
    </Box>
  );
};
